// extracted by mini-css-extract-plugin
module.exports = {"box":"KeyTakeaways_box__qYH1d","title":"KeyTakeaways_title__7VD6C","list":"KeyTakeaways_list__NTQyw"};